import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on route changes so in-app navigation
 * (buttons, links) does not keep the previous page's scroll position.
 * Skips when the URL has a hash — the target page handles anchor scrolling.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      return;
    }

    const scrollTop = (): void => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollTop();
    requestAnimationFrame(() => {
      scrollTop();
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
